import './linteditor/codemirror-init';
import './global.css';
import Main from './main';

export default new Main();
